/**
 * View component for /content-modules/:contentModuleId
 *
 * Displays a single contentModule from the 'byId' map in the contentModule reducer
 * as defined by the 'selected' property
 */

const simUrl = window.simUrl;

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, history, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import * as contentModuleActions from '../contentModuleActions';
import Base from "../../../global/components/BaseComponent.js.jsx";
import ContentModuleLayout from '../components/ContentModuleLayout.js.jsx';

/**
 * Goal: we don't want to break legacy redstone routes (yet)
 * The old overview page uses :slug, and the new one uses :id, so we need to load it here before redirecting
 */


class ContentModuleOverviewRedirect extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, loggedInUser, match } = this.props;
    dispatch(contentModuleActions.fetchSingleBySlug(match.params.contentModuleSlug)).then((action) => {

      // redirect to athens for this item
      window.location = `${simUrl}/content-modules/${action.item._id}/overview`;

    });
  }

  render() {
    // console.log("RENDER SINGLE CONTENT MODULE");
    const {
      location
      , loggedInUser
      , match
      , contentModuleStore
    } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual contentModule object from the map
     */
    const selectedContentModule = contentModuleStore.selected.getItem();

    const isEmpty = (
      !selectedContentModule
      || !selectedContentModule._id
      || contentModuleStore.selected.didInvalidate
      // || courseStore.selected.isFetching
      // || !courseStore.selected.id
    );

    return (
      <ContentModuleLayout>
        <Helmet
          title={"...loading | Pro-ficiency"}
        />
        <div className="flex tm-overview">
          <section className="section">
            <div className="yt-container">
            </div>
          </section>
        </div>
      </ContentModuleLayout>
    )
  }
}

ContentModuleOverviewRedirect.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    loggedInUser: store.user.loggedIn.user
    , contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(ContentModuleOverviewRedirect)
);



// WEBPACK FOOTER //
// modules/contentModule/views/ContentModuleOverviewRedirect.js.jsx